import { ReactElement, useEffect, useState } from 'react';
import { convertTimeTo12HourFormat } from '@helper/utils';
import { IQrModal } from '@components/dashboard/components/meeting/index';
import QRCode from 'react-qr-code';
import { BIG_MEETS } from '@config/constant';
export const QrModal = (props: IQrModal): ReactElement => {
	const { meetingData, modalClose, qrId, isCloseVisible = true } = props;

	const isBigMeetingType = (meetingType: string): boolean => {
		if (!meetingType) return false;
		const type = meetingType.toLowerCase();
		return BIG_MEETS.includes(type);
	};

	const [qrValue, setQrValue] = useState<string>(() => {
		if (!meetingData?.sfid) return '';

		return isBigMeetingType(meetingData?.meeting_type_c)
			? meetingData.sfid
			: `${meetingData.sfid ?? qrId}_${Date.now()}`;
	});

	useEffect(() => {
		if (meetingData?.meeting_type_c && isBigMeetingType(meetingData.meeting_type_c)) {
			setQrValue(meetingData?.sfid);
			return;
		}
		if (!isBigMeetingType(meetingData?.meeting_type_c ?? '')) {
			setQrValue(`${meetingData?.sfid ?? qrId}_${Date.now()}`);

			const interval = setInterval(() => {
				setQrValue(`${meetingData?.sfid ?? qrId}_${Date.now()}`);
			}, 5000);

			return (): void => clearInterval(interval);
		}
	}, [meetingData?.sfid, qrId, meetingData?.meeting_type_c]);

	return (
		<div className="qr-code-wrapper">
			{(meetingData?.sfid || qrId) && <QRCode value={qrValue} size={200} style={{ height: '200px' }} />}

			{meetingData && <p className="h3">{meetingData?.name}</p>}

			{meetingData && (
				<span className="date">
					{meetingData?.status && `${meetingData?.status}, `}
					{convertTimeTo12HourFormat(meetingData?.start_time_c)}
				</span>
			)}

			{isCloseVisible && (
				<button className="close" onClick={modalClose}>
					Close
				</button>
			)}
		</div>
	);
};
